var map = {
	"./": 142,
	"./Clutch": 2717,
	"./Clutch.js": 2717,
	"./NewUi": 2718,
	"./NewUi.js": 2718,
	"./OldUi": 2719,
	"./OldUi.js": 2719,
	"./index": 142,
	"./index.js": 142,
	"./style": 871,
	"./style.js": 871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4251;